import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor( private readonly toastController: ToastController ) { }

  async presentSimpleToast ( message: string, duration: number, position: 'top' | 'bottom' | 'middle' = 'bottom', color: string = undefined ) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      position: position,
      color: color,
      cssClass: 'ion-text-center'
     });
     await toast.present();     
  }

}
